export default {
  ERROR: 'progressToolbarError'
};
